module.exports = [{
  plugin: require('/vercel/workpath0/node_modules/@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/vercel/workpath0/apollo-day/deck.mdx",
    "dirname": "/vercel/workpath0/apollo-day"
  }
}];